import { useMutation, useQuery, useQueryClient } from "react-query";

import { UseGetProductGroupsParams } from "../types";

import {
  addProductGroup,
  deleteProductGroup,
  editProductGroup,
  getProductGroups,
} from "./index";

export const useGetProductsGroup = ({
  enabled,
}: UseGetProductGroupsParams = {}) => {
  return useQuery(
    ["get-product-groups"],
    () => getProductGroups(),
    { enabled }
  );
};

const useSuccess = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-product-groups"] });
  };
};

export const useDeleteProductsGroup = () => {
  const onSuccess = useSuccess();

  return useMutation(["delete-product-group"], deleteProductGroup, {
    onSuccess,
  });
};

export const useAddProductsGroup = () => {
  const onSuccess = useSuccess();

  return useMutation(["add-product-group"], addProductGroup, {
    onSuccess,
  });
};

export const useEditProductsGroup = () => {
  const onSuccess = useSuccess();

  return useMutation(["edit-product-group"], editProductGroup, {
    onSuccess,
  });
};
